import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { EmptyState } from "../components/ui.jsx";
import { useDocumentTitle, useLocalePath } from "../i18n/hooks.js";

export default function NotFound() {
  useDocumentTitle("notFound.title");
  const lp = useLocalePath();
  return (
    <div className="page">
      <div className="card">
        <EmptyState
          icon="search"
          title={<FormattedMessage id="notFound.title" />}
          body={<FormattedMessage id="notFound.body" />}
          action={
            <Link className="btn btn-primary" to={lp("/")}>
              <FormattedMessage id="billing.toDashboard" />
            </Link>
          }
        />
      </div>
    </div>
  );
}
